package com.narbase.letsgo.web.views.linkshare

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.dto.dto
import com.narbase.letsgo.web.dto.linkshare.LinkShareLogDto
import com.narbase.letsgo.web.dto.linkshare.LinkShareRewardSettingDto
import com.narbase.letsgo.web.dto.linkshare.TopLinkDto
import com.narbase.letsgo.web.models.linkshare.LinkShareDateRange
import com.narbase.letsgo.web.models.linkshare.TopLinksSortBy
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.linkshare.GetLinkShareLogsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.GetLinkShareRewardSettingsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.GetLinkShareTopLinksEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.SetLinkShareRewardsDisabledEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.UpsertLinkShareRewardSettingEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class LinkSharesManagementViewModel {

    val logsUiState = Observable<BasicUiState>()
    var logs: Array<LinkShareLogDto> = arrayOf()
    var logsTotal = 0
    var logsPageNo = 0
    var logsPageSize = 20

    var fSharedByPassengerId: KmmLong? = null
    var fOpenedByPassengerId: KmmLong? = null
    var fShareToken: String? = null
    var fRideFinalStatus: String? = null
    var fRewardSent: Boolean? = null

    fun getLogs() {
        basicNetworkCall(logsUiState) {
            val dto = GetLinkShareLogsEndpoint.Request(
                pageNo = logsPageNo,
                pageSize = logsPageSize,
                sharedByPassengerId = fSharedByPassengerId,
                openedByPassengerId = fOpenedByPassengerId,
                shareToken = fShareToken,
                rideId = null,
                rideCreated = null,
                rideFinalStatus = fRideFinalStatus,
                sharedLocationType = null,
                sharedFrom = null,
                sharedTo = null,
                openedFrom = null,
                openedTo = null,
                rewardEligible = null,
                rewardSent = fRewardSent,
                os = null,
                webVersion = null,
            )
            val response = GetLinkShareLogsEndpoint.remoteProcess(dto).data
            logs = response.list
            logsTotal = response.total
        }
    }

    fun applyLogFilters() {
        logsPageNo = 0
        getLogs()
    }

    fun getNextLogsPage() { logsPageNo++; getLogs() }
    fun getPreviousLogsPage() { if (logsPageNo > 0) { logsPageNo--; getLogs() } }

    val settingsUiState = Observable<BasicUiState>()
    val upsertUiState = Observable<BasicUiState>()

    /**
     * There is a single link-share reward setting. Load it (or null if none has been created yet) and hand it
     * to [onLoaded] so the caller can open the edit dialog directly instead of rendering a list.
     */
    fun loadSingleSetting(onLoaded: (LinkShareRewardSettingDto?) -> Unit) {
        basicNetworkCall(settingsUiState) {
            val dto = GetLinkShareRewardSettingsEndpoint.Request(0, 1, null)
            val response = GetLinkShareRewardSettingsEndpoint.remoteProcess(dto).data
            onLoaded(response.list.firstOrNull())
        }
    }

    fun upsertSetting(setting: LinkShareRewardSettingDto, onDone: () -> Unit) {
        basicNetworkCall(upsertUiState) {
            UpsertLinkShareRewardSettingEndpoint.remoteProcess(UpsertLinkShareRewardSettingEndpoint.Request(setting))
            onDone()
        }
    }

    val topLinksUiState = Observable<BasicUiState>()
    var topLinks: Array<TopLinkDto> = arrayOf()
    var topLinksTotal = 0
    var topLinksPageNo = 0
    var topLinksPageSize = 20
    var topLinksSortBy = TopLinksSortBy.CLICKS
    var topLinksDateRange = LinkShareDateRange.THIS_MONTH
    var topLinksCustomFrom: KmmLong? = null
    var topLinksCustomTo: KmmLong? = null

    fun getTopLinks() {
        basicNetworkCall(topLinksUiState) {
            val dto = GetLinkShareTopLinksEndpoint.Request(
                pageNo = topLinksPageNo,
                pageSize = topLinksPageSize,
                sortBy = topLinksSortBy.dto(),
                dateRange = topLinksDateRange.dto(),
                customFrom = topLinksCustomFrom,
                customTo = topLinksCustomTo,
            )
            val response = GetLinkShareTopLinksEndpoint.remoteProcess(dto).data
            topLinks = response.list
            topLinksTotal = response.total
        }
    }

    fun applyTopLinksFilters() {
        topLinksPageNo = 0
        getTopLinks()
    }

    fun getNextTopLinksPage() { topLinksPageNo++; getTopLinks() }
    fun getPreviousTopLinksPage() { if (topLinksPageNo > 0) { topLinksPageNo--; getTopLinks() } }

    val setRewardsDisabledUiState = Observable<BasicUiState>()

    fun setRewardsDisabled(shareToken: String, disabled: Boolean, onDone: () -> Unit) {
        basicNetworkCall(setRewardsDisabledUiState) {
            SetLinkShareRewardsDisabledEndpoint
                .remoteProcess(SetLinkShareRewardsDisabledEndpoint.Request(shareToken, disabled))
            onDone()
        }
    }
}
